<template>
  <vs-row vs-justify="space-between" v-if="simulation !== null">
    <div class="flex w-full mb-2 space-x-2">
      <vs-alert v-if="validFor > 0"
        >Warning: Due to security policies downloading and logging will be
        disabled after
        {{ validFor > 1 ? `${validFor} days` : `${validFor} day` }} from
        creation date of the simulation.</vs-alert
      >
      <vs-alert v-else
        >Warning: Due to security policies downloading and logging will be
        disabled after your license is expired.</vs-alert
      >
      <button
        @click="print"
        class="flex items-center justify-center px-6 text-white whitespace-no-wrap bg-indigo-500 rounded-lg"
      >
        <i class="mr-2 fa fa-download"></i>
        <span>Print PDF</span>
      </button>
    </div>
    <!-- Simulation Flow Chart -->
    <vs-col vs-w="3.9" vs-xs="0">
      <vx-card style="height: 575px">
        <div class="flex flex-col items-center justify-center">
          <h5 class="text-1xl">Simulation Flow Chart</h5>
          <div class="container pt-12 mx-auto text-center">
            <div class="flex items-center justify-center">
              <div class="text-center">
                <div class="flex flex-col items-center justify-center">
                  <div class="w-32 h-16">
                    <v-icon
                      :name="`brands/${simulation.operatingSystem.icon}`"
                      :title="simulation.operatingSystem.name"
                      scale="3"
                      class="block m-auto"
                    ></v-icon>
                  </div>
                  <div>
                    <p>{{ simulation.operatingSystem.name }}</p>
                  </div>
                </div>
                <ul class="flex flex-row justify-center mt-10">
                  <div
                    class="absolute h-10 -mt-10 border-l-2 border-gray-400"
                  ></div>
                  <li class="relative p-6">
                    <div
                      class="absolute top-0 h-8 border-t-2 border-gray-400"
                      style="left: 50%; right: 50%"
                    ></div>
                    <div class="relative flex justify-center">
                      <div
                        class="absolute top-0 h-6 -mt-6 border-l-2 border-gray-400"
                      ></div>
                      <div class="text-center">
                        <div class="flex flex-col items-center justify-center">
                          <div class="w-32 h-16">
                            <template v-if="simulation.language.logo">
                              <img
                                :src="getImage(simulation.language.logo)"
                                class="block p-1 m-auto rounded shadow-md cursor-pointer"
                                style="max-width: 150px; height: 3.5em"
                              />
                            </template>
                            <template v-else>
                              <i
                                :class="`icon-${simulation.language.icon}`"
                                class="block m-auto"
                                style="font-size: 3em"
                              ></i>
                            </template>
                          </div>
                          <div class="text-gray-600">
                            <p>{{ simulation.language.name }}</p>
                          </div>
                        </div>
                        <ul class="flex flex-row justify-center mt-10">
                          <div
                            class="absolute h-10 -mt-10 border-l-2 border-gray-400"
                          ></div>
                          <li class="relative p-6">
                            <div
                              class="absolute top-0 h-8 border-t-2 border-gray-400"
                              style="left: 50%; right: 0px"
                            ></div>
                            <div class="relative flex justify-center">
                              <div
                                class="absolute top-0 h-6 -mt-6 border-l-2 border-gray-400"
                              ></div>
                              <div class="text-center">
                                <div
                                  class="flex flex-col items-center justify-center"
                                >
                                  <div class="w-32 h-16">
                                    <img
                                      :src="
                                        getImage(simulation.protection.logo)
                                      "
                                      class="block m-auto"
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                      "
                                    />
                                  </div>
                                  <div class="text-gray-600">
                                    <p>{{ simulation.protection.name }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li class="relative p-6">
                            <div
                              class="absolute top-0 h-8 border-t-2 border-gray-400"
                              style="left: 0px; right: 50%"
                            ></div>
                            <div class="relative flex justify-center">
                              <div
                                class="absolute top-0 h-6 -mt-6 border-l-2 border-gray-400"
                              ></div>
                              <div class="text-center">
                                <div
                                  class="flex flex-col items-center justify-center"
                                >
                                  <div class="w-32 h-16">
                                    <img
                                      class="block m-auto"
                                      :src="
                                        require('@/assets/images/mitre.png')
                                      "
                                      alt="Mitre Attack"
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                      "
                                      v-if="simulation.attackType === 'mitre'"
                                    />
                                    <img
                                      class="block m-auto"
                                      :src="
                                        require('@/assets/images/svg/apt.svg')
                                      "
                                      alt="APT Scenario"
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                      "
                                      v-else-if="simulation.attackType === 'apt'"
                                    />
                                    <img
                                      class="block m-auto"
                                      :src="
                                        require('@/assets/images/custom-attack.png')
                                      "
                                      alt="Custom Attack"
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                      "
                                      v-else
                                    />
                                  </div>
                                  <div class="text-gray-600">
                                    <p v-if="simulation.attackType === 'mitre'">
                                      Mitre Att&ck
                                    </p>
                                    <p v-else-if="simulation.attackType === 'apt'">APT Scenario</p>
                                    <p v-else>Custom Attack</p>
                                  </div>
                                </div>
                                <ul
                                  class="flex flex-row justify-center mt-10"
                                  v-if="simulation.attackType === 'custom'"
                                >
                                  <div
                                    class="absolute h-10 -mt-10 border-l-2 border-gray-400"
                                  ></div>
                                  <li class="relative p-6">
                                    <div
                                      class="absolute top-0 h-8 border-t-2 border-gray-400"
                                      style="left: 50%; right: 50%"
                                    ></div>
                                    <div class="relative flex justify-center">
                                      <div
                                        class="absolute top-0 h-6 -mt-6 border-l-2 border-gray-400"
                                      ></div>
                                      <div class="text-center">
                                        <div
                                          class="flex flex-col items-center justify-center"
                                        >
                                          <div class="w-32 h-16">
                                            <img
                                              class="block m-auto"
                                              :src="
                                                getImage(
                                                  simulation.attackName.logo
                                                )
                                              "
                                              :alt="simulation.attackName.name"
                                              style="
                                                width: 100%;
                                                height: 100%;
                                                object-fit: contain;
                                              "
                                            />
                                          </div>
                                          <div class="text-gray-600">
                                            <p>
                                              {{ simulation.attackName.name }}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                                <ul
                                  class="flex flex-row justify-center mt-10"
                                  v-if="simulation.attackType === 'apt'"
                                >
                                  <div
                                    class="absolute h-10 -mt-10 border-l-2 border-gray-400"
                                  ></div>
                                  <li class="relative p-6">
                                    <div
                                      class="absolute top-0 h-8 border-t-2 border-gray-400"
                                      style="left: 50%; right: 50%"
                                    ></div>
                                    <div class="relative flex justify-center">
                                      <div
                                        class="absolute top-0 h-6 -mt-6 border-l-2 border-gray-400"
                                      ></div>
                                      <div class="text-center">
                                        <div
                                          class="flex flex-col items-center justify-center"
                                        >
                                          <div class="text-gray-600">
                                            <p>
                                              {{ simulation.attackName.name }}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-col>
    <!-- Simulation Logs -->
    <vs-col vs-w="4.9" vs-xs="0">
      <vs-row vs-type="flex" vs-justify="flex-end">
        <div class="w-full vx-col">
          <vx-card>
            <h5 class="mb-10 text-center">Simulation Logs</h5>
            <vue-perfect-scrollbar
              class="log-area"
              v-if="simulation.logs.length > 0"
            >
              <vx-timeline :data="simulation.logs" />
            </vue-perfect-scrollbar>
            <div
              class="block mx-auto my-3 text-center"
              style="height: 285px"
              v-else
            >
              <img
                :src="require('@/assets/images/svg/no-data.svg')"
                style="width: 100%; height: 90%; object-fit: contain"
              />
              <p>Looks like there is no activity here...</p>
            </div>
          </vx-card>
        </div>
      </vs-row>
    </vs-col>
    <!-- Simulation Status & Logs -->
    <vs-col vs-w="2.9" vs-xs="0">
      <!-- Simulation Status -->
      <vs-row vs-type="flex" vs-justify="flex-end">
        <div class="w-full mb-2 vx-col">
          <statistics-card-line
            hideChart
            :downloadable="simulation.status === 1"
            :downloadLink="getDownloadLink"
            :icon="simulation.status === 0 ? 'ActivityIcon' : 'CheckCircleIcon'"
            :statistic="simulation.status === 0 ? 'In-Progress' : 'Completed'"
            statisticTitle="Simulation Status"
            :color="simulation.status === 0 ? 'warning' : 'success'"
          />
        </div>
      </vs-row>
      <!-- Simulation Details -->
      <vx-card>
        <h5 class="text-center">Simulation Details</h5>
        <div
          class="container flex flex-col justify-center pt-8 mx-auto text-center"
        >
          <div class="flex justify-between mb-2" v-if="simulation.tag">
            <span>Tag</span>
            <span class="font-semibold">{{ simulation.tag }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Operating System</span>
            <span class="font-semibold">{{
              simulation.operatingSystem.name
            }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Programming Language</span>
            <span class="font-semibold">{{ simulation.language.name }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Protection</span>
            <span class="font-semibold">{{ simulation.protection.name }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Attack Type</span>
            <span class="font-semibold">{{ simulation.attackType }}</span>
          </div>
          <div
            class="flex justify-between mb-2"
            v-if="
              simulation.attackType === 'apt' ||
              simulation.attackType === 'custom'
            "
          >
            <span>Attack Name</span>
            <span class="font-semibold">{{ simulation.attackName.name }}</span>
          </div>
          <div
            class="flex justify-between mb-2"
            v-if="
              simulation.attackType === 'mitre' ||
              simulation.attackType === 'apt'
            "
          >
            <span>Techniques</span>
            <span class="font-semibold">{{
              simulation.techniques.length > 3
                ? simulation.techniques.slice(0, 3) + "..."
                : simulation.techniques
            }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Created At</span>
            <span class="font-semibold">{{
              simulation.createdAt | moment("DD/MM/YYYY HH:mm")
            }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span>Last Update</span>
            <span class="font-semibold">{{
              simulation.createdAt | moment("DD/MM/YYYY HH:mm")
            }}</span>
          </div>
        </div>
      </vx-card>
    </vs-col>
    <exportable-simulation
      id="printMe"
      class="hidden"
      :simulation="simulation"
      v-if="simulation !== null"
    />
  </vs-row>
</template>

<script>
import VxTimeline from "@/components/timeline/VxTimeline";
import ExportableSimulation from "./ExportableSimulation";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  components: {
    VxTimeline,
    ExportableSimulation,
    StatisticsCardLine,
    VuePerfectScrollbar,
  },
  data() {
    return {
      simulation: null,
      validFor: 0,
      printing: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.loadDetail();
      }
    },
  },
  computed: {
    getDownloadLink() {
      return `${process.env.VUE_APP_BASE_URL}/user/download/${this.simulation._id}`;
    },
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    async getNumberOfDayForPackage() {
      const profileData = await this.$http.get("/user/profile");
      this.validFor = profileData.data.user.packageType.validFor;
    },
    getImage(image_id) {
      return `${process.env.VUE_APP_BASE_URL}/images/${image_id}`;
    },
    loadDetail() {
      this.$vs.loading();
      this.$http
        .get("/user/simulations", {
          params: { id: this.$route.params.id },
        })
        .then((res) => {
          if (res.data.status && res.data.status === true) {
            this.simulation = res.data.simulation;
            this.$vs.loading.close();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$router.push("/login");
        });
    },
  },
  created() {
    this.loadDetail();
    this.getNumberOfDayForPackage();
  },
};
</script>

<style>
.log-area {
  position: relative;
  margin: auto;
  height: auto;
  max-height: 50vh;
}
</style>